import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Button, Card, CardBody, Col, Container, Input, Label, Row, Nav, NavItem, NavLink,
  Modal, ModalBody, ModalHeader, Spinner, Badge, Form
} from "reactstrap";
import classnames from "classnames";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Bildirimler = () => {
  document.title = "Bildirim Merkezi | LojGo";

  // --- ROL VE AUTH KONTROLÜ ---
  const authUser = JSON.parse(localStorage.getItem("authUser"));
  const userId = authUser?.ID;
  const isAdmin = authUser?.Users_Type_ID === 3;

  // --- STATE YÖNETİMİ ---
  const [activeTab, setActiveTab] = useState("inbox");
  const [notifications, setNotifications] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  
  // Modal State'leri (Yeni Bildirim Gönderme)
  const [composeModal, setComposeModal] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [usersList, setUsersList] = useState([]);
  const [formData, setFormData] = useState({
    Receiver_ID: "all", // "all" = Herkese, ID = Belirli kişiye
    Title: "",
    Message: ""
  });

  const toggleComposeModal = () => setComposeModal(!composeModal);

  // --- 1. BİLDİRİMLERİ ÇEKME ---
  const fetchNotifications = async () => {
    setIsLoading(true);
    try {
      const filterStr = isAdmin ? "" : `$filter=Receiver_ID eq ${userId} or Receiver_ID eq 0&`;
      const response = await fetch(`https://hiflowapi.stechomeyazilim.info/Notifications?${filterStr}$orderby=Created_DateTime desc`);
      const result = await response.json();

      if (result && result.value) {
        setNotifications(result.value.map(item => ({
          id: item.ID,
          title: item.Notifications_Title || "Sistem Bildirimi",
          message: item.Notifications_Desc || "",
          date: item.Created_DateTime ? new Date(item.Created_DateTime).toLocaleString('tr-TR') : "-",
          isRead: item.Is_Read || false,
          type: item.Type || "general" // general, important, system
        })));
      }
    } catch (error) {
      console.error("Bildirimler çekilemedi:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // --- 2. KULLANICI LİSTESİNİ ÇEKME (SADECE ADMİN) ---
  const fetchUsersForDropdown = async () => {
    if (isAdmin) {
      try {
        const response = await fetch("https://hiflowapi.stechomeyazilim.info/Users?$select=ID,Users_NameSurname");
        const result = await response.json();
        if (result && result.value) setUsersList(result.value);
      } catch (error) {
        console.error("Kullanıcılar yüklenemedi:", error);
      }
    }
  };

  useEffect(() => {
    fetchNotifications();
    fetchUsersForDropdown();
  }, [isAdmin]);

  // --- 3. BİLDİRİM GÖNDERME (POST) ---
  const handleSendNotification = async (e) => {
    e.preventDefault();
    setIsSending(true);

    const payload = {
      Sender_ID: userId,
      Receiver_ID: formData.Receiver_ID === "all" ? 0 : parseInt(formData.Receiver_ID),
      Title: formData.Title,
      Message: formData.Message,
      Is_Read: false,
      Created_DateTime: new Date().toISOString()
    };

    try {
      const response = await fetch("https://hiflowapi.stechomeyazilim.info/Notifications", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });

      if (response.ok) {
        toast.success("Bildirim başarıyla gönderildi!");
        toggleComposeModal();
        setFormData({ Receiver_ID: "all", Title: "", Message: "" });
        fetchNotifications(); // Listeyi yenile
      } else {
        toast.error("Gönderim başarısız oldu.");
      }
    } catch (error) {
      toast.error("Bağlantı hatası.");
    } finally {
      setIsSending(false);
    }
  };

  // Filtreleme Mantığı
  const filteredNotifications = notifications.filter(notif => {
    if (activeTab === "inbox") return true;
    if (activeTab === "unread") return !notif.isRead;
    if (activeTab === "important") return notif.type === "important";
    return true;
  });

  const unreadCount = notifications.filter(n => !n.isRead).length;

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="İletişim" breadcrumbItem="Bildirim Merkezi" />

          <Row>
            {/* SOL MENÜ */}
            <Col lg="3" md="4" className="mb-4">
              <Card className="border-0 shadow-sm rounded-4 h-100">
                <CardBody className="p-4">
                  {/* SADECE ADMİN İSE YENİ BİLDİRİM BUTONU GÖRÜNÜR */}
                  {isAdmin && (
                    <div className="mb-4">
                      <Button color="primary" className="w-100 fw-bold py-2 shadow-sm rounded-3" onClick={toggleComposeModal}>
                        <i className="mdi mdi-plus-circle-outline fs-5 align-middle me-2"></i> Yeni Bildirim Gönder
                      </Button>
                    </div>
                  )}

                  <h6 className="text-muted fw-bold text-uppercase mb-3 font-size-12">Menü</h6>
                  
                  <Nav pills className="flex-column gap-2 custom-nav-pills">
                    <NavItem>
                      <NavLink 
                        className={classnames("d-flex justify-content-between align-items-center cursor-pointer rounded-3 px-3 py-2", { active: activeTab === "inbox" })} 
                        onClick={() => setActiveTab("inbox")}
                      >
                        <div>
                          <i className="mdi mdi-bell-outline me-2 fs-5 align-middle"></i> 
                          <span className="fw-medium">Tüm Bildirimler</span>
                        </div>
                        {unreadCount > 0 && <Badge color="danger" pill>{unreadCount}</Badge>}
                      </NavLink>
                    </NavItem>

                    <NavItem>
                      <NavLink 
                        className={classnames("d-flex align-items-center cursor-pointer rounded-3 px-3 py-2", { active: activeTab === "unread" })} 
                        onClick={() => setActiveTab("unread")}
                      >
                        <i className="mdi mdi-email-open-outline me-2 fs-5 align-middle"></i> 
                        <span className="fw-medium">Okunmamışlar</span>
                      </NavLink>
                    </NavItem>

                    <NavItem>
                      <NavLink 
                        className={classnames("d-flex align-items-center cursor-pointer rounded-3 px-3 py-2", { active: activeTab === "important" })} 
                        onClick={() => setActiveTab("important")}
                      >
                        <i className="mdi mdi-alert-decagram-outline me-2 fs-5 align-middle text-warning"></i> 
                        <span className="fw-medium">Önemli Duyurular</span>
                      </NavLink>
                    </NavItem>
                  </Nav>
                </CardBody>
              </Card>
            </Col>

            {/* BİLDİRİMLER LİSTESİ */}
            <Col lg="9" md="8">
              <Card className="border-0 shadow-sm rounded-4">
                <div className="p-4 border-bottom d-flex align-items-center justify-content-between bg-white rounded-top">
                   <h5 className="mb-0 text-dark fw-bold">
                      {activeTab === "inbox" && "Tüm Bildirimler"}
                      {activeTab === "unread" && "Okunmamış Bildirimler"}
                      {activeTab === "important" && "Önemli Duyurular"}
                   </h5>
                   <Button color="light" size="sm" className="fw-bold" onClick={fetchNotifications}>
                     <i className="mdi mdi-refresh fs-5 align-middle me-1"></i> Yenile
                   </Button>
                </div>
                
                <CardBody className="p-4 bg-light bg-opacity-50">
                  {isLoading ? (
                    <div className="text-center py-5">
                        <Spinner color="primary" />
                        <p className="mt-3 text-muted fw-medium">Bildirimler yükleniyor...</p>
                    </div>
                  ) : filteredNotifications.length > 0 ? (
                    <div className="d-flex flex-column gap-3">
                      {filteredNotifications.map((notif) => (
                        <div 
                            key={notif.id} 
                            className={`p-3 rounded-3 border bg-white shadow-sm transition-all ${!notif.isRead ? 'border-primary border-2' : 'border-light'}`}
                            style={{ cursor: "pointer" }}
                        >
                          <div className="d-flex align-items-start">
                            {/* Sol İkon */}
                            <div className="flex-shrink-0 me-3">
                              <div className="avatar-sm">
                                <span className={`avatar-title rounded-circle fs-4 ${notif.type === 'important' ? 'bg-soft-warning text-warning' : (!notif.isRead ? 'bg-primary text-white' : 'bg-light text-secondary')}`}>
                                  <i className={`mdi ${notif.type === 'important' ? 'mdi-alert-decagram' : 'mdi-bell'}`}></i>
                                </span>
                              </div>
                            </div>
                            
                            {/* İçerik */}
                            <div className="flex-grow-1">
                              <div className="d-flex flex-wrap justify-content-between align-items-center mb-1">
                                <h6 className={`mb-0 ${!notif.isRead ? 'fw-bold text-dark' : 'text-secondary fw-medium'}`}>
                                  {notif.title}
                                </h6>
                                <small className="text-muted fw-medium font-size-12 mt-1 mt-sm-0">
                                  <i className="mdi mdi-clock-outline me-1"></i>{notif.date}
                                </small>
                              </div>
                              <p className={`mb-0 mt-2 font-size-14 ${!notif.isRead ? 'fw-medium text-dark' : 'text-muted'}`} style={{ lineHeight: "1.6" }}>
                                {notif.message}
                              </p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="align-items-center text-center py-5">
                      <div className="avatar-lg mx-auto mb-4">
                        <span className="avatar-title rounded-circle bg-soft-light text-muted fs-1 border">
                           <i className="mdi mdi-bell-sleep-outline"></i>
                        </span>
                      </div>
                      <h5 className="text-dark fw-bold">Bildirim Bulunamadı</h5>
                      <p className="text-muted mb-0">Şu anda görüntülenecek herhangi bir bildiriminiz yok.</p>
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* BİLDİRİM GÖNDERME MODALI (ADMİN) */}
      <Modal isOpen={composeModal} toggle={toggleComposeModal} centered size="lg" className="border-0">
        <div className="modal-content border-0 rounded-4 shadow-lg">
          <ModalHeader toggle={toggleComposeModal} className="bg-primary text-white p-4 border-0">
            <i className="mdi mdi-bullhorn-outline me-2 fs-4 align-middle"></i> Sistem Bildirimi Gönder
          </ModalHeader>
          <ModalBody className="p-4 bg-white">
            <Form onSubmit={handleSendNotification}>
              <div className="mb-4">
                <Label className="fw-bold text-muted font-size-12 text-uppercase">Kime Gönderilecek?</Label>
                <Input type="select" className="form-select-lg font-size-14 bg-light border-light fw-medium" value={formData.Receiver_ID} onChange={(e) => setFormData({...formData, Receiver_ID: e.target.value})}>
                  <option value="all">Tüm Sistem Kullanıcılarına (Genel Duyuru)</option>
                  <optgroup label="Bireysel Kullanıcılar">
                    {usersList.map(u => <option key={u.ID} value={u.ID}>{u.Users_NameSurname}</option>)}
                  </optgroup>
                </Input>
              </div>

              <div className="mb-4">
                <Label className="fw-bold text-muted font-size-12 text-uppercase">Bildirim Başlığı</Label>
                <Input type="text" className="form-control-lg font-size-14 bg-light border-light" required placeholder="Örn: Evrak Güncellemesi Hakkında" value={formData.Title} onChange={(e) => setFormData({...formData, Title: e.target.value})} />
              </div>
              
              <div className="mb-4">
                <Label className="fw-bold text-muted font-size-12 text-uppercase">Mesaj İçeriği</Label>
                <Input type="textarea" rows="6" required className="form-control-lg font-size-14 bg-light border-light" placeholder="Kullanıcıya iletilecek detaylı mesajınızı buraya yazın..." value={formData.Message} onChange={(e) => setFormData({...formData, Message: e.target.value})} />
              </div>

              <div className="d-flex justify-content-end gap-3 pt-3 border-top">
                <Button type="button" color="light" className="fw-bold px-4" onClick={toggleComposeModal}>Vazgeç</Button>
                <Button type="submit" color="primary" className="fw-bold px-4 d-flex align-items-center" disabled={isSending}>
                  {isSending ? <Spinner size="sm" color="light" className="me-2" /> : <i className="mdi mdi-send fs-5 me-2"></i>} 
                  Bildirimi Gönder
                </Button>
              </div>
            </Form>
          </ModalBody>
        </div>
      </Modal>

      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
    </React.Fragment>
  );
};

export default Bildirimler;